import { useMemo, useState } from "react";
import { X } from "lucide-react";
import SearchableSelect from "@/components/SearchableSelect";

/**
 * TeamCCPicker (2026-06-20): multi-picker user untuk Team CC task.
 * Chips (dengan tombol X) + searchable dropdown untuk menambah anggota.
 * Props: value = array user id; onChange(ids); excludeIds = id yg tidak bisa dipilih
 * (creator/assignee); disabled = mode read-only (hanya tampil chips).
 */
export default function TeamCCPicker({ users = [], value = [], onChange, excludeIds = [], disabled = false, testid = "team-cc" }) {
  // key dipakai utk reset SearchableSelect setelah 1 anggota ditambahkan.
  const [pickerKey, setPickerKey] = useState(0);

  const nameOf = useMemo(() => {
    const m = {};
    (users || []).forEach((u) => { if (u?.id) m[u.id] = u.name; });
    return m;
  }, [users]);

  const options = useMemo(() => (users || [])
    .filter((u) => u?.id && u.is_active !== false && !u.disabled_at && !value.includes(u.id) && !excludeIds.includes(u.id))
    .map((u) => ({ value: u.id, label: `${u.name}${u.division ? ` · ${u.division}` : ""}` })),
  [users, value, excludeIds]);

  return (
    <div data-testid={testid}>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2" data-testid={`${testid}-chips`}>
          {value.map((uid) => (
            <span key={uid} data-testid={`${testid}-chip-${uid}`}
              className="inline-flex items-center gap-1 px-2 py-0.5 bg-[#0B1D3A]/5 border border-[#0B1D3A]/20 text-[11px] text-[#0B1D3A] font-medium">
              {nameOf[uid] || uid}
              {!disabled && (
                <button type="button" data-testid={`${testid}-remove-${uid}`} aria-label={`Hapus ${nameOf[uid] || uid}`}
                  onClick={() => onChange(value.filter((x) => x !== uid))}
                  className="text-slate-400 hover:text-rose-600">
                  <X size={11} />
                </button>
              )}
            </span>
          ))}
        </div>
      )}
      {!disabled && (
        <SearchableSelect
          key={pickerKey}
          testid={`${testid}-add`}
          value=""
          onChange={(v) => {
            if (v && !value.includes(v)) onChange([...value, v]);
            setPickerKey((k) => k + 1);
          }}
          options={options}
          placeholder="Tambah anggota CC…"
          searchPlaceholder="Ketik nama…"
        />
      )}
      {disabled && value.length === 0 && (
        <div className="text-[11px] text-slate-400" data-testid={`${testid}-empty`}>Belum ada Team CC.</div>
      )}
    </div>
  );
}
